import React, { memo } from 'react';
import PaperIcon from '../../components/icons/PaperIcon';
import BaseBadge from '../../components/badges/BaseBadge';

const BundleBadge = ({ shiftsCount, bundleId }) => {
	const tooltipHtml = (
		<>
			This shift is a part <br />
			of a {shiftsCount} shift bundle. ID - {bundleId}
		</>
	);

	return <BaseBadge tooltipHtml={tooltipHtml} badgeCopy="Bundle" className="bundle-badge" icon={<PaperIcon />} />;
};

export default memo(BundleBadge);
